import { Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ClientControlService from "./ClientControlService";
import DefaultChip from "../../componentes/chip/DefaultChip";
/**
 * Author : AndréK
 * 26/08/2022
*/
const columns = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "email",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="email" name="email" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.email}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "contact",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="contact" name="user" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.contact}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status == 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const ClientEmail = ({ idClient }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        idClient: idClient,
        email: "",
        contact: "",
        rows: [],
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, email, contact, status } = state
    const { success, error, rows, ...data } = state

    const handleChange = ({ target: { name, value } }) => {

        dispatch({ type: 'update', data: { [name]: value } })
    }

    const handleSearch = () => {
        ClientControlService
            .getClientEmail(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const canSave = () => email !== "" && contact !== "";

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                ClientControlService
                    .updateClientEmail(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                ClientControlService
                    .createClientEmail(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }
    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                email: data.email,
                contact: data.contact,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])

    return (
        <DefaultScreenAccordion
            title={"clientEmail"}
            isRegister
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="email" labelName="email" />
                                }
                                name="email"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={email}
                                inputProps={{ maxLength: 50 }}
                                error={error && email === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="user" labelName="contact" />
                                }
                                name="contact"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={contact}
                                inputProps={{ maxLength: 50 }}
                                error={error && contact === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"status"}
                                onChange={handleChange}
                                value={status}
                                label={t("status")}
                                defaultSize
                                error={error && status === 2}
                                items={[
                                    { id: 0, name: t("canceled"), status: 1 },
                                    { id: 1, name: t("active"), status: 1 },
                                    { id: 2, name: t("all"), status: 1 },
                                ]}
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSearch={handleSearch}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        onClickSave={handleSaveUpdate}
                    />
                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    allowPaging={true}
                                    dataSource={rows}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}